import {
    Dashboard, People, Settings,
    Assignment, LibraryBooks, Category,
    Quiz, AssignmentTurnedIn, LibraryAddCheck, CardGiftcard
} from '@mui/icons-material';


export const menuItems = [
    // { label: 'Dashboard', icon: <Dashboard />, path: '/admin/dashboard' },
    { label: 'Users', icon: <People />, path: '/manage-students' },
     { label: 'Vouchers', icon: <CardGiftcard />, path: '/admin-vouchers' },
    { label: 'Exams', icon: <Assignment />, path: '/admin/exams' },
    { label: 'Subjects', icon: <LibraryBooks />, path: '/admin/subjects' },
    { label: 'Topics', icon: <Category />, path: '/admin/topics' },
    { label: 'Questions', icon: <Quiz />, path: '/admin/questions' },
    { label: 'Create Questions Sets', icon: <AssignmentTurnedIn />, path: '/admin/questions-set' },
    { label: 'Manage Questions Sets', icon: <LibraryAddCheck />, path: '/admin/manage-question-sets' },
    { label: 'Settings', icon: <Settings />, path: '/admin/settings' },
];
